var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "QueueItem",
    { on: { "handle-click": _vm.launchModal } },
    [
      _c(
        "QueueItemDetail",
        {
          staticClass: "queue-item__detail--notes grid__col--6",
          attrs: { item: _vm.item }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "queue-detail queue-detail__title queue-detail__title--fuel-color"
            },
            [_vm._v(_vm._s(_vm.item.title))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "queue-detail queue-detail__text queue-detail__text--small",
            domProps: { innerHTML: _vm._s(_vm.item.description) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "QueueItemDetail",
        {
          staticClass:
            "grid__col--3 queue-item__detail--notes queue-item__detail--no-horiz-padding",
          attrs: { item: _vm.item }
        },
        [
          _c("People", { attrs: { item: _vm.item } }),
          _vm._v(" "),
          _vm._l(_vm.agendaFiles, function(file, index) {
            return _c("FileAttachment", { key: index, attrs: { file: file } })
          }),
          _vm._v(" "),
          _c("CommentCount", { attrs: { item: _vm.item } })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "QueueItemDetail",
        {
          staticClass: "queue-item__detail--notes grid__col--3",
          attrs: { item: _vm.item }
        },
        [
          _vm.item.note
            ? _c(
                "div",
                { staticClass: "queue-detail queue-detail__text grid" },
                [
                  _c(
                    "div",
                    { staticClass: "grid__col--1 h-no-padding h-center-align" },
                    [_c("i", { staticClass: "fas fa-sticky-note" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid__col--11 h-no-margin h-no-padding" },
                    [
                      _c("div", {
                        staticClass: "item-header__note-text",
                        domProps: { innerHTML: _vm._s(_vm.item.note) }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }